import { FC } from 'react';
import { TranslateFn, useTranslate } from 'hooks/useTranslate';

type TradingOfferOperationDetailDocumentationItemProps = {
  document?: string | { description?: string; name?: string; _id?: string };
  description?: string;
};

const getLabel = (
  isPending: boolean,
  document: string | { name?: string; _id?: string },
  t: TranslateFn
) => {
  if (isPending) {
    return t('PendingDocumentation');
  }
  if (typeof document === 'string') {
    return document;
  }
  if (document && typeof document === 'object' && document.name) {
    return document.name;
  }
  return t('Document');
};

const getDescription = (
  descriptionKey?: string,
  document?: string | { description?: string; _id?: string }
) => {
  if (descriptionKey) {
    return descriptionKey;
  }
  if (document && typeof document === 'object' && document.description) {
    return document.description;
  }
  return undefined;
};

const TradingOfferOperationDetailDocumentationItem: FC<
  TradingOfferOperationDetailDocumentationItemProps
> = ({ document, description }) => {
  const { t } = useTranslate();

  const isPending = document === undefined || document === null;

  const label = getLabel(isPending, document ?? '', t);

  const descriptionText = getDescription(description, document ?? '');

  if (isPending) {
    return (
      <div className="col-12">
        <div className="doc-item doc-falta">
          <div className="doc-icon bg-light text-secondary">
            <em className="icon ni ni-file-pdf" />
          </div>
          <div className="flex-grow-1 min-w-0">
            <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
              <strong className="fs-13px">{label}</strong>
              <span className="doc-estado">{t('DocumentMissing')}</span>
            </div>
            {descriptionText && (
              <div className="text-soft fs-12px mt-1">{t(descriptionText)}</div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="col-12">
      <div className="doc-item doc-presente">
        <div className="doc-icon bg-success-dim text-success">
          <em className="icon ni ni-check" />
        </div>
        <div className="flex-grow-1 min-w-0">
          <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
            <strong className="fs-13px">{label}</strong>
            <span className="doc-estado">{t('DocumentPresent')}</span>
          </div>
          {descriptionText && (
            <div className="text-soft fs-12px mt-1">{t(descriptionText)}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TradingOfferOperationDetailDocumentationItem;
